import Api from '../../services/api';

export const GET_TOKEN = 'GET_TOKEN';
export const GET_URL = 'GET_URL';

const getToken = (qiniuKey) => {
    return new Promise((resolve, reject) => {
        Api.QiniuService.token({
            qiniuKey,
            bucketKey: 'PUBLIC'
        }).then(resolve, reject);
    });
};

const getUrl = (qiniuKey) => {
    return new Promise((resolve, reject) => {
        Api.QiniuService.url({
            qiniuKey,
            isPublic: true,
            bucketKey: 'PUBLIC'
        }).then(resolve, reject);
    });
};

export default {
    getToken,
    getUrl
};